import { render, staticRenderFns } from "./DrugsPage.vue?vue&type=template&id=1b7ca378&scoped=true"
import script from "./DrugsPage.vue?vue&type=script&lang=js"
export * from "./DrugsPage.vue?vue&type=script&lang=js"
import style0 from "./DrugsPage.vue?vue&type=style&index=0&id=1b7ca378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ca378",
  null
  
)

export default component.exports